
class Meta {

  constructor (
    count,
    currentPage,
    perPage,
    total,
    totalPages
  ) {
    this.count = count;
    this.currentPage = currentPage;
    this.perPage = perPage;
    this.total = total;
    this.totalPages = totalPages;
  }

}

export class APIResult {

  constructor (collection, meta) {
    this.collection = collection;
    this.meta = new Meta(
      meta.pagination.page.items,
      meta.pagination.page.number,
      meta.pagination.page.size,
      meta.pagination.items,
      meta.pagination.pages
    );
  }

}



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/http.js
 **/